import { render, staticRenderFns } from "./editar-version.vue?vue&type=template&id=370e7072&"
import script from "./editar-version.vue?vue&type=script&lang=js&"
export * from "./editar-version.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports